import createInstance, { BASE_URL, DEVICE_CONNECTION_URL } from './createInstance';

export const api = createInstance({
  baseURL: `${BASE_URL}/v1`,
});

export const loginApi = createInstance({
  baseURL: `${BASE_URL}/v1`,
  withAuth: false,
});

export const deviceConnectionApi = createInstance({
  baseURL: DEVICE_CONNECTION_URL,
  withAuth: false,
  withLogout: false,
  responseTransform: (res) => ({ response: res.data, statusCode: 200 }),
});

export const deviceManagerApi = createInstance({
  baseURL: `${BASE_URL}/devicemanager/v1`,
});

export const firmwareApi = createInstance({
  baseURL: `${BASE_URL}/v1`,
  responseTransform: (res) => ({ ...res }),
});
